import { createContext } from "react";

// Order status can be shown before its account is identified. Only ordinary
// deposit events need to wait for NORMAL ownership.
export const RechargeReturnContext = createContext({ orderId: null, businessType: "NORMAL" });
